import React, { useEffect, useState } from 'react';
import { useStore } from "react-redux";
import useMedia from 'use-media';
import image_Pulldown from '../../../resources/icons/arw_pulldown.svg';
import image_Hamburger from '../../../resources/icons/ico_list.svg';
import img_memo from '../../../resources/icons/ico_memo.svg';
import img_save from '../../../resources/icons/ico_save.svg';
import { Image } from '../../atoms/image';
import img_modal from '../../../resources/icons/ico_modal.svg';
import MembershipPlanSearchSpContainer from './membershipPlanSearchSpContainer';

export const MembershipPlanTitleContainer = (props) => {
    const {
        login,
        state,
        onClickOpenCheckListWindow,
        onClickOpenCalendarWindow,
        onClickOpenReservationPopupWindow,
        handleSaveSearchCondition,
        handlePlanList,
        createAgeCountList,
        setDispFacility,
        setLoadingFlg,
    } = props;

    const sortList = [
        { option: "価格 安い順" }, { option: "価格 高い順" },
    ]
    //state
    const [popFlg, setPopFlg] = useState(false);
    const conditionsClick = () => {
        setPopFlg(true);
    };
    const store = useStore();

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);

    const [roomNum, setRoomNum] = useState("");
    const [checkInDate, setCheckInDate] = useState("");
    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
        const roomList = store.getState().room;
        const dispRoom = roomList.find(value => value.selected) ? roomList.find(value => value.selected).value : ""
        setRoomNum(dispRoom);

        let date = new Date(store.getState().checkIn);
        let year = date.getFullYear() + "年";
        let month = date.getMonth() + 1 + "月";
        let day = date.getDate() + "日";
        setCheckInDate(year + month + day);
    })

    // 施設表示
    const getFacility = () => {
        let dispText = store.getState().dispFacility ? store.getState().dispFacility : "選択なし";
        return dispText;
    }

    return (

        <div>
            {popFlg ?
                <MembershipPlanSearchSpContainer
                    state={state}
                    setPopFlg={setPopFlg}
                    onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    handlePlanList={handlePlanList}
                    createAgeCountList={createAgeCountList}
                    setLoadingFlg={setLoadingFlg}
                />
                :
                null
            }
            {isWideTablet ?
                //レスポンシブ対応
                <div style={isWideTablet ? styles.textSp : styles.text}>
                    <div onClick={conditionsClick} style={styles.textbox}>
                        {getFacility() + "/" + checkInDate + "/" + roomNum}
                    </div>
                    <div>
                        <div style={styles.saveWrap}>
                            <div style={styles.save}>
                                <Image image={img_save} style={styles.imageSave} />
                                <div style={styles.saveConditions}
                                    onClick={handleSaveSearchCondition} >この検索条件を保存</div>
                            </div>
                            <div style={styles.save}>
                                <Image image={img_memo} style={styles.imageSave} />
                                <div style={styles.saveConditions}
                                    onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)} >保存した検索条件</div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                null
            }
        </div>
    )
}

const styles = {
    text: {
        textAlign: "center",
        width: "800px",
    },
    textSp: {
        textAlign: "center",
        width: "100%",
        backgroundColor: "#EBEBEB",
        paddingTop: "20px",
    },
    textbox: {
        height: "25px",
        width: "calc(90% - 37px)",
        fontSize: "1rem",
        border: "1px solid gray",
        margin: "0px auto",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        padding: "10px 30px 5px 5px",
        overflow: "hidden",
        backgroundColor: "white",
        backgroundImage: `url(${img_modal})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        fontWeight: "600",
        color: "gray",
    },
    breadCrumb: {
        display: "flex",
        color: "gray",
        marginLeft: "calc(16% + 15px)",
        marginTop: "10px",
        textAlign: "left",
    },
    breadCrumb2: {
        display: "none",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    pan: {
        display: "inline-block",
        padding: "3px",
        color: "gray",
        fontSize: "small",
    },
    panLink: {
        display: "inline-block",
    },
    panLabel: {
        display: "inline-block",
    },
    selectStyle: {
        float: "right",
        width: "150px",
        height: "30px",
        backgroundImage: `url(${image_Hamburger}),url(${image_Pulldown})`,
        backgroundSize: "20px 15px , 25px ",
        backgroundPosition: "left,right",
        backgroundRepeat: "no-repeat",
        webkitAppearance: "none",
        paddingLeft: "35px",
        //direction: "rtl",
        direction: "unset",
        fontSize: "small",
    },
    saveWrap: {
        display: "flex",
        width: "90%",
        justifyContent: "space-between",
        margin: "0px auto"
    },
    save: {
        border: "1px solid gray",
        margin: "20px 0px",
        fontSize: "small",
        textAlign: "left",
        padding: "5px",
        backgroundColor: "white",
        width: "45%"
    },
    imageSave: {
        position: "absolute",
    },
    saveConditions: {
        marginLeft: "25px",
    },
}